import React, { FC, useEffect, useRef, useState } from 'react';
import { map } from 'lodash';
import * as styles from './ColorConfigurationPreview.module.scss';

type Props = {
  finishes: [color: string, label: string][];
  previews: Queries.DatoCmsAssetFragment[];
};

const ColorConfigurationPreview: FC<Props> = ({ finishes, previews }) => {
  const [isLoading, setIsLoading] = useState(false);
  const image = useRef<HTMLImageElement>(null);
  const [selectedIndex, setSelectedIndex] = useState(0);
  const preview = previews[selectedIndex];

  useEffect(() => {
    setIsLoading(true);
  }, [selectedIndex]);

  useEffect(() => {
    const handleImageLoad = () => setIsLoading(false);
    const instance = image.current;
    if (instance) {
      instance.addEventListener('load', handleImageLoad);
    }

    return () => {
      instance?.removeEventListener('load', handleImageLoad);
    };
  }, [image.current]);

  return (
    <div className={styles.main}>
      <div className={styles.preview}>
        <img ref={image} src={preview?.image?.images?.fallback?.src} alt="" />
      </div>
      <div
        className={styles.finishes}
        role="menu"
        id="product-options"
        aria-label="Select color"
      >
        {map(finishes, ([color, label], index) => (
          <div
            key={index}
            className={styles.finish}
            role="menuitem"
            tabIndex={0}
            onClick={() => setSelectedIndex(index)}
          >
            <span
              className={styles.sample}
              style={
                {
                  '--color-configuration-preview-sample-color': color,
                } as React.CSSProperties
              }
            />
            <span className={styles.label}>{label}</span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ColorConfigurationPreview;
